import React from 'react'
import NotifierClose from './components/notifier'
import { v4 } from 'uuid'

export const SWITCH_THEME = 'SWITCH_THEME'
export function switchTheme(theme) {
    return {
        type: SWITCH_THEME,
        theme: theme
    }
}

export const SET_LOCALE = 'SET_LOCALE'
export function setLocale(localeCode) {
    return {
        type: SET_LOCALE,
        localeCode: localeCode
    }
}

export const SAVE_LOCALE_REQUEST = 'SAVE_LOCALE_REQUEST'
export function saveLocaleRequest(localeCode) {
    return {
        type: SAVE_LOCALE_REQUEST,
        localeCode: localeCode
    }
}

export const SAVE_LOCALE_SUCCESS = 'SAVE_LOCALE_SUCCESS'
export function saveLocaleSuccess() {
    return {
        type: SAVE_LOCALE_SUCCESS
    }
}

export const SAVE_LOCALE_ERROR = 'SAVE_LOCALE_ERROR'
export function saveLocaleError() {
    return {
        type: SAVE_LOCALE_ERROR
    }
}

export const START_LOADING = 'START_LOADING'
export function startLoading() {
    return {
        type: START_LOADING,
        isLoading: true
    }
}

export const STOP_LOADING = 'STOP_LOADING'
export function stopLoading() {
    return {
        type: STOP_LOADING,
        isLoading: false
    }
}

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const enqueueSnackbar = notification => {
    return {
        type: ENQUEUE_SNACKBAR,
        notification: {
            key: v4(),
            message: notification.message,
            options: {
                action: key => <NotifierClose notifierKey={key} />,
                ...notification.options
            }
        }
    }
}

export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const closeSnackbar = key => ({
    type: CLOSE_SNACKBAR,
    key
})

export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'
export const removeSnackbar = key => ({
    type: REMOVE_SNACKBAR,
    key
})

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export function login(userBody) {
    return {
        type: LOGIN_REQUEST,
        userBody
    }
}

export const LOGIN_WITH_TS_REQUEST = 'LOGIN_WITH_TS_REQUEST'
export function loginWithTs(userBody) {
    return {
        type: LOGIN_WITH_TS_REQUEST,
        userBody
    }
}

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export function loginSuccess(token, user, p) {
    return {
        type: LOGIN_SUCCESS,
        token,
        user,
        p
    }
}

export const LOGIN_ERROR = 'LOGIN_ERROR'
export function loginError() {
    return {
        type: LOGIN_ERROR
    }
}

export const LOGOUT = 'LOGOUT'
export function logout() {
    return {
        type: LOGOUT
    }
}

export const CHECK_ROUTE_REQUEST = 'CHECK_ROUTE_REQUEST'
export function checkRouteRequest(userId, history) {
    return {
        type: CHECK_ROUTE_REQUEST,
        userId,
        history
    }
}

export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST'
export function profileUpdateRequest(body) {
    return {
        type: PROFILE_UPDATE_REQUEST,
        body
    }
}

export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS'
export function profileUpdateSuccess(userData) {
    return {
        type: PROFILE_UPDATE_SUCCESS,
        userData
    }
}

export const PROFILE_UPDATE_ERROR = 'PROFILE_UPDATE_ERROR'
export function profileUpdateError() {
    return {
        type: PROFILE_UPDATE_ERROR
    }
}

export const PROFILE_CHANGE_PASSWORD_REQUEST = 'PROFILE_CHANGE_PASSWORD_REQUEST'
export function profileChangePasswordRequest(body) {
    return {
        type: PROFILE_CHANGE_PASSWORD_REQUEST,
        body
    }
}

export const PROFILE_CHANGE_PASSWORD_SUCCESS = 'PROFILE_CHANGE_PASSWORD_SUCCESS'
export function profileChangePasswordSuccess() {
    return {
        type: PROFILE_CHANGE_PASSWORD_SUCCESS
    }
}

export const PROFILE_CHANGE_PASSWORD_ERROR = 'PROFILE_CHANGE_PASSWORD_ERROR'
export function profileChangePasswordError() {
    return {
        type: PROFILE_CHANGE_PASSWORD_ERROR
    }
}

export const SET_IS_TERMS_STEP = 'SET_IS_TERMS_STEP'
export function setIsTermsStep(isTermsStep) {
    return {
        type: SET_IS_TERMS_STEP,
        isTermsStep
    }
}

export const SET_TEMP_CREDS = 'SET_TEMP_CREDS'
export function setTempCreds(tempCreds) {
    return {
        type: SET_TEMP_CREDS,
        tempCreds
    }
}

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export function forgotPasswordRequest(email) {
    return {
        type: FORGOT_PASSWORD_REQUEST,
        email
    }
}

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export function forgotPasswordSuccess() {
    return {
        type: FORGOT_PASSWORD_SUCCESS
    }
}

export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR'
export function forgotPasswordError() {
    return {
        type: FORGOT_PASSWORD_ERROR
    }
}

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export function resetPasswordRequest(token, password) {
    return {
        type: RESET_PASSWORD_REQUEST,
        token,
        password
    }
}

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export function resetPasswordSuccess() {
    return {
        type: RESET_PASSWORD_SUCCESS
    }
}

export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
export function resetPasswordError() {
    return {
        type: RESET_PASSWORD_ERROR
    }
}

export const GET_PROFILE_USER = 'GET_PROFILE_USER'
export function getProfileUser(userId) {
    return {
        type: GET_PROFILE_USER,
        userId
    }
}

export const GET_PROFILE_USER_SUCCESS = 'GET_PROFILE_USER_SUCCESS'
export function getProfileUserSuccess(user) {
    return {
        type: GET_PROFILE_USER_SUCCESS,
        user
    }
}

export const GET_PROFILE_USER_ERROR = 'GET_PROFILE_USER_ERROR'
export function getProfileUserError() {
    return {
        type: GET_PROFILE_USER_ERROR
    }
}

export const RELOAD_USER = 'RELOAD_USER'
export function reloadUser(adminReload) {
    return {
        type: RELOAD_USER,
        payload: { adminReload }
    }
}

export const GET_HAS_TOM_DEVICES = 'GET_HAS_TOM_DEVICES'
export function getHasTomDevices() {
    return {
        type: GET_HAS_TOM_DEVICES
    }
}

export const GET_HAS_TOM_DEVICES_SUCCESS = 'GET_HAS_TOM_DEVICES_SUCCESS'
export function getHasTomDevicesSuccess(hasTomDevices) {
    return {
        type: GET_HAS_TOM_DEVICES_SUCCESS,
        hasTomDevices
    }
}

export const SET_ORGANISATION_PHONE = 'SET_ORGANISATION_PHONE'
export function setOrganisationPhoneNumber(data) {
    return {
        type: SET_ORGANISATION_PHONE,
        data
    }
}

export const SET_ORGANISATION_PHONE_SUCCESS = 'SET_ORGANISATION_PHONE_SUCCESS'
export function setOrganisationPhoneNumberSuccess(data) {
    return {
        type: SET_ORGANISATION_PHONE_SUCCESS,
        data
    }
}

export const SET_ORGANISATION_PHONE_ERROR = 'SET_ORGANISATION_PHONE_ERROR'
export function setOrganisationPhoneNumberError() {
    return {
        type: SET_ORGANISATION_PHONE_ERROR
    }
}

export const GET_ORGANISATION_DATA_REQUEST = 'GET_ORGANISATION_DATA_REQUEST'
export function getOrganisationDataRequest(customerId) {
    return {
        type: GET_ORGANISATION_DATA_REQUEST,
        customerId
    }
}

export const GET_ORGANISATION_DATA_SUCCESS = 'GET_ORGANISATION_DATA_SUCCESS'
export function getOrganisationDataSuccess(organisationData) {
    return {
        type: GET_ORGANISATION_DATA_SUCCESS,
        organisationData
    }
}

export const CHANGE_DASHBOARD_TYPE = 'CHANGE_DASHBOARD_TYPE'
export function changeDashboardType(option) {
    return {
        type: CHANGE_DASHBOARD_TYPE,
        option
    }
}
export const SET_USER_NOTIFICATIONS_SETTINGS = 'SET_USER_NOTIFICATIONS_SETTINGS'
export function setUserNotificationsSettings(notifications) {
    return {
        type: SET_USER_NOTIFICATIONS_SETTINGS,
        notifications
    }
}

export const CLEAN_USER_NOTIFICATIONS_SETTINGS =
    'CLEAN_USER_NOTIFICATIONS_SETTINGS'
export function setCleanUserNotificationsSettings() {
    return {
        type: CLEAN_USER_NOTIFICATIONS_SETTINGS
    }
}

export const IMPERSONATE_SUCCESS = 'IMPERSONATE_SUCCESS'
export function impersonateSuccess(token, user, p, i) {
    return {
        type: IMPERSONATE_SUCCESS,
        token,
        user,
        p,
        i
    }
}

export const SET_TWO_FACTOR_TOKEN = 'SET_TWO_FACTOR_TOKEN'
export function setTwoFactorToken({ twoFactorToken }) {
    return {
        type: SET_TWO_FACTOR_TOKEN,
        twoFactorToken
    }
}

export const VERIFY_2FA_REQUEST = 'VERIFY_2FA_REQUEST'
export function verifyTwoFactorRequest({ twoFactorToken, code }) {
    return {
        type: VERIFY_2FA_REQUEST,
        twoFactorToken,
        code
    }
}
